export default "__VITE_ASSET__qqCoc_Td__"